import React from 'react';
import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  acceptUnknownImportsCreator,
  rejectUnknownImportsCreator,
} from 'store/actionsCreators';
import { setIpmaCisProfileCreator } from '../../../../store/actionsCreators';
import UnknownImports from '../../../../shared/Cis/UnknownImports/UnknownImports';

const mapStateToProps = ({ loading, ipma, user }) => ({
  loading: isLoading(loading, 'LOAD_IMPORTER_UNKNOWN'),
  list: ipma.cis.unknownImports,
  appType: user.appType,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('unknownImports')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('unknownImports', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('unknownImports', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('unknownImports', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('unknownImports', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('unknownImports')),
  acceptEntry: (payload) => dispatch(acceptUnknownImportsCreator(payload, 'ipma')),
  rejectEntry: (payload) => dispatch(rejectUnknownImportsCreator(payload, 'ipma')),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('unknownImports', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnknownImports);
